import { backend } from "../utils/axios";

const ROUTE = "/request-print-email";

interface RequestPrintServiceEndpoints {
	requestPrintEmail: () => Promise<any>;
}

export const RequestPrintService: RequestPrintServiceEndpoints = {
	requestPrintEmail: () =>
		backend
			.get(`${ROUTE}`)
			.then(({ data }) => data)
			.catch(),
};
